import Services from "../services";

export default {
  install: Vue => {
    Object.defineProperty(Vue.prototype, "$service", { value: Services });
  }
};
